module.exports = __webpack_public_path__ + "img/where-app-tutorials-btn.73fc1bc1.png";